'use strict';
import isString from 'lodash/isString';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {PERSONNEL_COLLECTION} from '../domain/config';


module.exports = [
  '$timeout',
  '$cacheFactory',
  'PersonDomain',
  'TeamDomain',
  PersonnelService];

function PersonnelService($timeout, $cacheFactory, PersonDomain, TeamDomain) {
  const instanceCache = $cacheFactory('PersonnelService_instances');
  const nameCache = $cacheFactory('PersonnelService_names');
  const casualCache = $cacheFactory('PersonnelService_casual');

  this.getPerson = getPerson;
  this.getPersonAsync = getPersonAsync;
  this.getName = getName;
  this.getNameAsync = getNameAsync;
  this.getCasualName = getCasualName;
  this.getCasualNameAsync = getCasualNameAsync;

  function getPerson(id, collection = PERSONNEL_COLLECTION) {
    if (!id) return;
    const loadedPerson = instanceCache.get(id);
    if (getId(loadedPerson)) return loadedPerson;
    if (loadedPerson) return; // it's still a promise
    else fetchPerson(id, collection);
  }

  function getPersonAsync(id, collection = PERSONNEL_COLLECTION) {
    if (!id) return Promise.resolve(null);
    const loadedPerson = instanceCache.get(id);
    if (getId(loadedPerson)) return Promise.resolve(loadedPerson);
    if (loadedPerson) return loadedPerson; // it's still a promise
    else return fetchPerson(id, collection, instanceCache);
  }

  function getName(id, collection = PERSONNEL_COLLECTION) {
    if (!id) return;
    const name = nameCache.get(id);
    if (isString(name)) return name;
    if (name) return; // it's still a promise
    else fetchPerson(id, collection);
  }

  function getNameAsync(id, collection = PERSONNEL_COLLECTION) {
    if (!id) return;
    const name = nameCache.get(id);
    if (isString(name)) return name;
    if (name) return name; // it's still a promise
    else return fetchPerson(id, collection, nameCache);
  }

  function getCasualName(id, collection = PERSONNEL_COLLECTION) {
    if (!id) return;
    const name = casualCache.get(id);
    if (isString(name)) return name;
    if (name) return name; // it's still a promise
    else fetchPerson(id, collection);
  }

  function getCasualNameAsync(id, collection = PERSONNEL_COLLECTION) {
    if (!id) return;
    const name = casualCache.get(id);
    if (isString(name)) return name;
    if (name) return; // it's still a promise
    else return fetchPerson(id, collection, casualCache);
  }

  function fetchPerson(id, collection = PERSONNEL_COLLECTION, cache) {
    const promise = (collection === PERSONNEL_COLLECTION ? PersonDomain.$get(id) : TeamDomain.$get(id))
      .then(person => {
        if (person && person.toString()) {
          instanceCache.put(id, person);
          nameCache.put(id, person.toString());
          casualCache.put(id, person.getCasualName());
          return person;
        } else if (person) {
          return person.$loaded().then(() => {
            instanceCache.put(id, person);
            nameCache.put(id, person.toString());
            casualCache.put(id, person.getCasualName());
            return person;
          });
        } else {
          instanceCache.put(id, person);
          nameCache.put(id, '');
          casualCache.put(id, '');
          return person;
        }
      });
    instanceCache.put(id, promise); // store the promise until it resolves
    nameCache.put(id, promise.then(getLoadedName.bind(promise, id)));
    casualCache.put(id, promise.then(getLoadedCasualName.bind(promise, id)));

    if (cache) return cache.get(id);
  }

  // Delay event cycle to ensure the cache has been updated to the string value
  function getLoadedName(id) {
    return $timeout(() => nameCache.get(id));
  }

  // Delay event cycle to ensure the cache has been updated to the string value
  function getLoadedCasualName(id) {
    return $timeout(() => casualCache.get(id));
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/services/PersonnelService.js